import { Component, inject, input } from '@angular/core';
import { UserSearchResult } from '../../models/user.model';
import { TranslateService } from '@ngx-translate/core';
import { Plans } from '../../shared/constants/plan.constants';

@Component({
  selector: 'user-list',
  standalone: false,
  templateUrl: './user-list.component.html',
  styleUrl: './user-list.component.scss',
})
export class UserListComponent {
  users = input<UserSearchResult[]>();

  plans = Plans;
  private translate = inject(TranslateService);

  // TODO: duplicated
  openWhatsApp($event: MouseEvent, phoneNumber: string | undefined): void {
    $event.stopPropagation();
    if (!phoneNumber) {
      return; // or handle error / show message
    }

    // Remove spaces, dashes, etc.
    let normalized = phoneNumber.replace(/\D/g, '');

    // If number starts with 0, remove it
    if (normalized.startsWith('00')) {
      normalized = normalized.substring(2);
    }

    // Add the link of the current page
    const message = `${this.translate.instant('WHATSAPP_MESSAGE')} ${window.location.href}`;

    const encodedMessage = encodeURIComponent(message);

    const url = `https://wa.me/${normalized}?text=${encodedMessage}`;

    window.open(url, '_blank');
  }

  sendEmail($event: MouseEvent): void {
    $event.stopPropagation();

    const subject = encodeURIComponent(this.translate.instant('SHARE_HEADER'));
    const body = '';
    window.location.href = `mailto:info@bazar-s.com?subject=${subject}&body=${body}`;
  }
}
